/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { Analytics } from '../../../analytics/sendAnalyticsEvent';

export default (set, get) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const testEvent = {
    category: {
      primaryCategory: 'overlay'
    },
    eventInfo: {
      eventName: 'Packout Test Event'
    },
  };

  draft.digitalData.event.push(testEvent); // store cumulative event
  Analytics.sendAnalyticsEvent(testEvent);

}), false, { type: 'PACKOUT_TEST_EVENT' });
